import { render } from "./ContactPage.vue?vue&type=template&id=6c02ba22&scoped=true"
import script from "./ContactPage.vue?vue&type=script&lang=js"
export * from "./ContactPage.vue?vue&type=script&lang=js"

import "./ContactPage.vue?vue&type=style&index=0&id=6c02ba22&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c02ba22"]])

export default __exports__